import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MessageFilterService } from './message-filter.service';
import { MessageFilterActions } from './state/message-filter.actions';
import { MessageFilterEffects } from './state/message-filter.effects';
import { MessageFilterReducer, STORE_FEATURE_KEY_MESSAGE_FILTER } from './state/message-filter.reducer';
import { MessageFilterSelectors } from './state/message-filter.selectors';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(STORE_FEATURE_KEY_MESSAGE_FILTER, MessageFilterReducer),
        EffectsModule.forFeature([MessageFilterEffects])
    ],
    declarations: [
    ],
    providers: [
        // MessageFilterService, // already provided in root - don't provide both places
        MessageFilterActions,
        MessageFilterSelectors
    ]
})
export class MessageFilterModule {
}
